import * as React from 'react';
import { Controller } from '@tencent/workbench';
import { TOOLBAR_ITEMS } from './config';

/**
 * 收折后，可能需要替换的图标
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class FoldController {
    constructor() {
    }
}
